// extracted by css-extract-rspack-plugin
export default {"cls1":"CollapsedActivityPreview-cls1_idr","cls2":"CollapsedActivityPreview-cls2_JPF CollapsedActivityPreview-cls1_idr"};